export default __webpack_public_path__ + "static/media/VideoThumbnail3.bc9e23a7.svg";